import { ChevronLeft } from 'lucide-react';

import { ShareDirections } from './ShareDirections';

import { Button } from '@/components/ui/button';
import { useSearchStore } from '@/store/SearchStore';

export const SearchSummary = () => {
  const { selectedRoute, locationStart, locationEnd, setSelectedRoute } = useSearchStore();

  if (!selectedRoute) return null;

  return (
    <div className="flex flex-col gap-4">
      <div
        role="button"
        className="flex w-full cursor-pointer items-center gap-2 text-left text-[var(--blue-one)] underline underline-offset-4 print:hidden"
        onClick={() => setSelectedRoute(undefined)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            setSelectedRoute(undefined);
          }
        }}
        tabIndex={0}
      >
        <ChevronLeft strokeWidth={1} className="-ml-2 h-5" />
        Back to results
      </div>
      <div className="lt-lg:hidden flex items-center justify-between gap-4">
        <div className="flex flex-col gap-1 text-lg">
          <div className="flex gap-2">
            <div className="font-light">From</div>
            <div className="font-medium text-balance">{locationStart?.displayName}</div>
          </div>
          <div className="flex gap-2">
            <div className="font-light">To</div>
            <div className="font-medium text-balance">{locationEnd?.displayName}</div>
          </div>
        </div>
        <ShareDirections className="lg:hidden" />
      </div>
      <div className="lt-lg:hidden flex gap-4">
        <ShareDirections>
          <Button>Share</Button>
        </ShareDirections>
        <Button variant="outline" className="print:hidden" onClick={() => window.print()}>
          Print
        </Button>
      </div>
    </div>
  );
};
